// extracted by mini-css-extract-plugin
export var orderDetails = "_sm-2";
export var orderImage = "_sm-1";
export var orderMeta = "_sm-3";
export var orderSummary = "_sm-0";
export var rightArrow = "_sm-4";